function openfilter(filter) {
    document.querySelector(filter).classList.add("open");
}

function closefilter(filter) {
    document.querySelector(filter).classList.remove("open");
}

function opensortby(sort) {
    document.querySelector(sort).classList.toggle("m-none");
}

window.onscroll = function () {
    var scrolly = window.scrollY;
    var header = document.querySelector(".latest-header");
    if (scrolly > 42) {
        // header.style.top = "0";
        header.style.backgroundColor = "#000"
    }
    else {
        // if (screen.width > 749) {
        //     header.style.top = "42px";
        // }
        // else {
        //     header.style.top = "51px";
        // }

        header.style.backgroundColor = "transparent";
    }
}

function miuns(qty) {
    var q = parseInt(document.querySelector(qty).value);
    q--;
    if (q > 0) {
        document.querySelector(qty).value = q
    }
}

function plus(qty) {
    var q = parseInt(document.querySelector(qty).value);
    q++;
    document.querySelector(qty).value = q
}

function openmenu() {
    document.querySelector(".latest-mobile-menu").classList.add("open");
    document.body.classList.add("menu-is-opend");
}

function closemenu() {
    document.querySelector(".latest-mobile-menu").classList.remove("open");
    document.body.classList.remove("menu-is-opend");
}

function togglefootermenu(menu) {
    menu.nextElementSibling.classList.toggle("m-none");
}

var product_bottom_slider = new Swiper(".product-bottom-slider", {
    slidesPerView: 4,
    spaceBetween: 15,
     direction: "vertical",
    mousewheel: true, 
    watchSlidesProgress: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        0: {
            slidesPerView: 4,
            spaceBetween: 10,
        },
        750: {
            slidesPerView: 4,
            spaceBetween: 15,
        }
    }
});

var product_top_image = new Swiper(".product-top-image", {
    slidesPerView: 1,
    spaceBetween: 21,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
      },
    thumbs: {
        swiper: product_bottom_slider,
    },
    breakpoints: {
        0: {
            slidesPerView: 1.3,
            spaceBetween: 8,
        },
        768: {
            slidesPerView: 1
        },
    },
});

function changeimage(id) {
    document.querySelectorAll(".product-bottom-slider .swiper-slide").forEach(function (slide, index) {
        if (slide.getAttribute("data-id") == id) {

            var product_bottom_slider = new Swiper(".product-bottom-slider", {
                slidesPerView: 4,
                spaceBetween: 15,
                direction: "vertical",
                mousewheel: true, 
                watchSlidesProgress: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    0: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                    },
                    750: {
                        slidesPerView: 4,
                        spaceBetween: 15,
                    }
                }
            });

            var product_top_image = new Swiper(".product-top-image", {
                slidesPerView: 1,
                spaceBetween: 21,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                 pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    type: 'bullets',
                },
                thumbs: {
                    swiper: product_bottom_slider,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.3,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 1
                    },
                },
            });

            if (index == 0) {

                product_bottom_slider.slideTo(1);
                product_bottom_slider.slideTo(0);
                product_bottom_slider.slideTo(-1);

                product_top_image.slideTo(1);
                product_top_image.slideTo(0);
                product_top_image.slideTo(-1);
            }
            else {
                product_bottom_slider.slideTo(index);
                product_top_image.slideTo(index);
            }
        }
    })
}


window.addEventListener('load', variant_product_info);

// Get actual variant compare at price

// js fixes for price starts here
function variant_product_info() {
  if (typeof frd_variant_id1 === 'undefined') return;

  const product_handle = frd_variant_id1.variant_handle;
  let variant_id = frd_variant_id1.variant_id;

  const frd_pdp_variants = document.querySelectorAll('.latest-variant-option .latest-option');
  const priceEl = document.querySelector('[frd-price]');
  const compareEl = document.querySelector('[frd-compare-price]');

  function updatePrice(variantId) {
    fetch(`/products/${product_handle}.js`)
      .then(res => res.json())
      .then(product => {
        const variant = product.variants.find(v => v.id === variantId);
        if (!variant) return;

        const price = Shopify.formatMoney(variant.price);
        const comparePrice = Shopify.formatMoney(variant.compare_at_price);

        priceEl.textContent = price;

        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = comparePrice;
          compareEl.classList.remove('hidden');
        } else {
          compareEl.classList.add('hidden');
        }
      });
  }

  frd_pdp_variants.forEach(option => {
    option.addEventListener('click', () => {
      const urlParams = new URLSearchParams(window.location.search);
      variant_id = parseInt(urlParams.get('variant')) || variant_id;
      updatePrice(variant_id);
    });
  });

  updatePrice(variant_id);
}
// js fixes for price ends here

function changemaster() {
    var master = document.querySelectorAll("#masterselect option");

    var selected = document.querySelectorAll(".latest-option.active");
    var variantname = '';

    for (let i = 0; i < selected.length; i++) {
        const element = selected[i].getAttribute("data-value");
        if (i == selected.length - 1) {
            variantname = variantname + element;
        }
        else {
            variantname = variantname + element + ' / ';
        }
    }

    var choosen = false;
    var available = false;
    var id = "";
    var price = "";
    for (let j = 0; j < master.length; j++) {
        const element = master[j].getAttribute("data-index");
        if (element == variantname) {
            id = master[j].getAttribute("value");
            document.querySelector("#masterselect").value = id;
            price = master[j].getAttribute("data-price");
            var choosen = true;
            available = master[j].getAttribute("data-available");
            var imageid = master[j].getAttribute("data-id");
            changeimage(imageid)
        }
    }

    var availabletext = document.querySelector("#masterselect").getAttribute("data-available-text");
    var soldouttext = document.querySelector("#masterselect").getAttribute("data-solout-text");
    var unavailabletext = document.querySelector("#masterselect").getAttribute("data-unavailable-text");

    const price_element = document.querySelector('p[frd-price]');

    if (choosen) {
        if (available == "true") {
            document.querySelector(".latest-add-to-cart-btn").textContent = availabletext;
            document.querySelector(".latest-add-to-cart-btn").removeAttribute("disabled");
        }
        else if (available == "false") {
            document.querySelector(".latest-add-to-cart-btn").textContent = soldouttext;
            document.querySelector(".latest-add-to-cart-btn").setAttribute("disabled", "disabled");
        }

        price_element.innerHTML = `${price}`;

    }
    else {
        price_element.innerHTML = unavailabletext;
        document.querySelector(".latest-add-to-cart-btn").textContent = unavailabletext;
        document.querySelector(".latest-add-to-cart-btn").setAttribute("disabled", "disabled")
    }

    var nextURL = window.location.pathname + "?variant=" + id;
    window.history.replaceState("", "", nextURL);
}

document.querySelectorAll(".latest-option").forEach(function (option) {
    option.addEventListener("click", function () {
        this.parentElement.querySelector(".active").classList.remove("active");
        this.classList.add("active");
        changemaster()
    })
})

document.querySelectorAll(".latest-option.active").forEach(function (option) {
    option.click();
})

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}

document.querySelectorAll(".show_more_collection").forEach(function (btn) {
    btn.addEventListener("click", function () {
        this.classList.add("hide");
        this.parentElement.previousElementSibling.querySelectorAll(".hide").forEach(function (element) {
            element.classList.remove("hide");
        });
    })
})


